import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/tools/phone-validator')({
  beforeLoad: async () => {
    throw redirect({
      to: '/$lang/tools/phone-validator',
      params: { lang: await getPreferredLang() },
      replace: true,
    })
  },
})
